module.exports = __webpack_public_path__ + "static/img/img_tdmall.9a3ccbf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/site/img_tdmall.jpg
// module id = mlzd
// module chunks = 0